import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@utils/seo";
import i18n from "@modules/shared/localization/i18n";
import { NotFound } from "@/defaults/NotFound";

export const Route = createFileRoute("/$locale/_layout/(public)/_public/404")({
  component: NotFoundPage,
  head: ({ params }) => {
    const t = i18n.getFixedT(params.locale);
    return {
      meta: [
        ...seo({
          title: t("Seo:notFound.title"),
          description: t("Seo:notFound.description"),
          robots: "noindex, nofollow",
        }),
      ],
    };
  },
});

function NotFoundPage() {
  return <NotFound />;
}
